import React, { useState, useContext } from "react";
import "./AdditionalServiceButton.css";
import { ThemeContext } from "../../Context/ThemeContext";
import { FormattedMessage, useIntl } from "react-intl";

const SubmitButton = ({ icon, text, link, onClick, disabled = false }) => {
  const intl = useIntl();

  const handleClick = () => {
    if (link) {
      window.open(link(), "_blank");
    } else if (onClick) {
      onClick();
    } else {
      alert("No link or onClick provided.");
    }
  };

  const [isHovered, setIsHovered] = useState(false);
  const themeContext = useContext(ThemeContext);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  function formatTimeString(str) {
    const pattern = /\{{TIME_([\d]+)\}}/;
    const match = str.match(pattern);
    if (!match) return str;

    const minutes = parseInt(match[1], 10);

    const MINUTES_IN_HOUR = 60;
    const MINUTES_IN_DAY = 60 * 24;

    let result;

    if (minutes < MINUTES_IN_HOUR) {
      result =
        `${minutes} ` +
        (minutes > 1
          ? intl.formatMessage({ id: "minutes" })
          : intl.formatMessage({ id: "minute" }));
    } else if (minutes < MINUTES_IN_DAY) {
      const hours = Math.floor(minutes / MINUTES_IN_HOUR);
      result = `${hours} hour${hours === 1 ? "" : "s"}`;
    } else {
      const days = Math.floor(minutes / MINUTES_IN_DAY);
      result = `${days} day${days === 1 ? "" : "s"}`;
    }

    return str.replace(pattern, result);
  }

  function formatRangeString(str) {
    const pattern = /\{{RANGE_([\d]+)\}}/;
    const match = str.match(pattern);
    if (!match) return str;

    const meters = parseInt(match[1], 10);
    const multiplier = themeContext.theme.isKilometers ? 1000 : 1600;

    let result;

    if (meters < multiplier) {
      result = `${meters} meter${meters === 1 ? "" : "s"}`;
    } else {
      const units = Math.floor(meters / multiplier);
      result =
        `${units} ` +
        (themeContext.theme.isKilometers ? "kilometer" : "mile") +
        (units === 1 ? "" : "s");
    }

    return str.replace(pattern, result);
  }

  return (
    <button
      className="additional-service-button"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
      onClick={handleClick}
      style={{
        backgroundColor: disabled
          ? themeContext.theme.disabledColour
          : isHovered
          ? themeContext.theme.hoverColour
          : themeContext.theme.primaryColour,
        color: disabled ? "black" : "white",
      }}
    >
      {icon && (
        <span
          style={{
            marginRight: "5px",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <span
            style={{
              height: "20px",
              width: "20px",
              display: "inline-block",
            }}
          >
            <IconComponent
              icon={icon}
              isHovered={isHovered}
              color={"white"}
              hoveredColor={"white"}
            />
          </span>
        </span>
      )}{" "}
      {formatRangeString(formatTimeString(text))}
    </button>
  );
};

const IconComponent = ({
  icon,
  isHovered,
  color = "black",
  hoveredColor = "white",
}) => {
  const coloredIcon = React.cloneElement(icon, {
    style: { fill: !isHovered ? color : hoveredColor },
  });

  return <div>{coloredIcon}</div>;
};

export default SubmitButton;
